import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './styles.module.scss';

const BUSINESS_RULE_IDS = [
  'certificates.detail.rule.1',
  'certificates.detail.rule.2',
  'certificates.detail.rule.3',
  'certificates.detail.rule.5',
  'certificates.detail.rule.6',
  'certificates.detail.rule.7',
] as const;

export const DetailBusinessRules: React.FC = () => {
  return (
    <section className={styles.section} aria-labelledby="business-rules-heading">
      <h2 id="business-rules-heading" className={styles.sectionTitle}>
        <FormattedMessage id="certificates.detail.businessRulesHeading" />
      </h2>
      <ul className={styles.list}>
        {BUSINESS_RULE_IDS.map((id) => (
          <li key={id}>
            <FormattedMessage id={id} />
          </li>
        ))}
      </ul>
    </section>
  );
};
